// extracted by mini-css-extract-plugin
module.exports = {"artist-featured-in":"artist-featured-in_artist-featured-in__u5Wut","artist-featured-in__title":"artist-featured-in_artist-featured-in__title__paFXQ"};